import React, { useState, useEffect } from 'react';
import helper from '../../../Services/helper';

const ImportDataProgressBar = (params) => {
    const [progress, setProgress] = useState(0);

    // Function to start the upload process
    const startUpload = () => {
        // This function will initiate the chunk upload and update progress
    };

    useEffect(() => {
        console.log('changed params: ', params)
    }, [params])

    return (
        <div className='import-progress-bar-area'>
            <div className="progress">
                <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: `${params?.progress}%`}} aria-valuenow={params?.progress} aria-valuemin="0" aria-valuemax="100">{params?.progress}%</div>
            </div>
            {params?.progress == 100 && <button className='btn btn-success mt-4 mx-auto' onClick={() => params.setProgress()}>{helper().translate("FINISHED_SUCCESSFULLY")}</button>}
        </div>
    );
};

export default ImportDataProgressBar;
